import { render, staticRenderFns } from "./transNotice.vue?vue&type=template&id=01761490&scoped=true"
import script from "./transNotice.vue?vue&type=script&lang=js"
export * from "./transNotice.vue?vue&type=script&lang=js"
import style0 from "./transNotice.vue?vue&type=style&index=0&id=01761490&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01761490",
  null
  
)

export default component.exports